import React from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import { detailparcelleStyles } from "./styles";
import { useState, useEffect } from "react";
import { useToast } from "../../../Context/ToastContext";
import { useTransactionsAndFaos } from "../../../Context/crm/TransactionsAndFaosContext";
import { faosService } from "../../../service/FaosService";

/*****Ui icons */
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const EnqueteDetail = ({ details }) => {
  const { faos, setFaos } = useTransactionsAndFaos();
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChanges = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const toaster = useToast();

  const fetchData = async () => {
    setLoading(true);
    if (details) {
      try {
        const landId = details.land_id;
        console.log("inside fetchData enquetes");
        const response = await faosService.findByLandId(landId);
        const data = response.data.results;
        const matchingEnquetes = await data.filter(
          (enq) => enq._source.lands_id === landId.toString()
        );
        console.log("matching enquetes : ", matchingEnquetes);
        setFaos(matchingEnquetes);
      } catch (error) {
        console.error("Erreur lors de la requête API :", error);
        toaster.notifyError("erreur : " + error.message);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [details]);

  useEffect(() => {
    setLoading(false);
  }, [faos]);

  const renderFaos = (faos) => {
    if (faos && faos.length > 0) {
      return faos.map((fao) => renderFaosLine(fao));
    }

    return <Typography variant="body1">Pas d'enquête disponible</Typography>;
  };

  const renderFaosLine = (enquete) => {
    return (
      <Accordion
        expanded={expanded === enquete._id}
        onChange={handleChanges(enquete._id)}
        key={enquete._id}
        sx={{ pb: 0 }}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          expandIcon={<ExpandMoreIcon />}
          sx={detailparcelleStyles.accordions}
        >
          <Typography
            sx={{
              width: "33.3%",
              textAlign: "start",
              ...detailparcelleStyles.mobileTitleSpacing,
              color: "#299CDB",
              fontWeight: "bold",
            }}
          >
            {enquete._source.type_name}
          </Typography>
          <Typography sx={{ width: "33.3%", textAlign: "center" }}>
            {enquete._source.work_type}
          </Typography>
          <Typography
            sx={{
              width: "33.3%",
              textAlign: "right",
              color: "#299CDB",
              fontWeight: "bold",
            }}
          >
            {enquete._source.inquiry_start_date}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ p: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Détails de l'enquête
              </Typography>
              <Box sx={{ pl: 2 }}>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Type :
                  </span>{" "}
                  {enquete._source.type_name}
                </p>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Travaux :
                  </span>{" "}
                  {enquete._source.work_type}
                </p>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Description :
                  </span>{" "}
                  {enquete._source.work_description}
                </p>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Date de début :
                  </span>{" "}
                  {enquete._source.inquiry_start_date}
                </p>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Architecte :
                  </span>{" "}
                  {enquete._source.architect}
                </p>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Résultat :
                  </span>{" "}
                  {enquete._source.result}
                </p>
                <p>
                  <span
                    style={{
                      color: detailparcelleStyles.graylight,
                      ...detailparcelleStyles.fontWeightTitle,
                    }}
                  >
                    Liens :
                  </span>{" "}
                  <Link
                    to={enquete._source.url_official}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {enquete._source.url_official}
                  </Link>
                </p>
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    );
  };

  return (
    <Box className="Layout bg-white my-4 rounded p-4" id="enquete">
      <Typography variant="h6" style={detailparcelleStyles.fontWeightTitle}>
        ENQUÊTES
      </Typography>
      <Box sx={{ p: 1, mt: 2 }}>
        {loading ? <CircularProgress /> : renderFaos(faos)}
      </Box>
    </Box>
  );
};

export default EnqueteDetail;
